import Player from '@vimeo/player';
import swal from 'sweetalert';

export class TestimonialPopup {
    constructor({testimonialId, questionId, showViewAllButton}) {
        this.testimonialId = testimonialId;
        this.questionId = questionId;
        this.showViewAllButton = showViewAllButton;
        this.apiUrl = window.testimonialData.sameQuestionApiRoute;
        this.currentVideo;
        this.isWide = false;
        this.swalContent = document.createElement('div');
        this.swalContent.classList.add('testimonial');
        this.mutationObserver = new MutationObserver(this.mutationFunction.bind(this));
        this.vimeoPlayers = [];
        const { closeButton } = window.testimonialsPageIcons;
        this.closeButton = closeButton;
    };

    mutationFunction(mutationsList) {
        mutationsList.forEach(mutation => {
            if (mutation.attributeName === 'class') {
                if (mutation.oldValue.includes('--show-modal')) {
                    $('.swal-carousell').slick('unslick');
                    $(mutation.target).remove();
                    if (this.vimeoPlayers.length > 0) {
                        this.vimeoPlayers.forEach((element) => {
                            element.destroy();
                        });
                        this.vimeoPlayers = [];
                    }
                }
            }
        });
    };

    addEventListeners() {
        $('.same-questions').on('click', '.same-question .user', (event) => {
            const next = $(event.currentTarget).data('next');

            $('.swal-content .testimonial .testimonial-slick').slick('slickGoTo', next !== undefined ? next : 1);
        });
        $('.testimonial').on('click', '.tags .tag', (event) => {
            const categoryId = $(event.currentTarget).data('id').toString();
            swal.close();
            window.testimonialFilter.handleTagClick(categoryId);
        });
    };

    openPopup() {
        this.preparePopup();
    };

    createPopup() {
        swal({
            className: 'swal-testimonial',
            content: this.swalContent,
            buttons: false
        });
    };

    async fetchData() {
        const axiosOptions = {
            params: {
                testimonialId: this.testimonialId,
                questionId: this.questionId
            }
        };

        try {
            const response = await axios.get(this.apiUrl, axiosOptions);

            return await response.data;
        } catch (error) {
            console.log(error);

            throw error;
        }
    };

    preparePopup() {
        this.fetchData().then(data => {
            this.testimonials = data?.data?.testimonials ?? [];
            this.mainUser = this.testimonials.find(el => el.id === this.testimonialId);
            this.currentVideo = this.testimonials.indexOf(this.mainUser);
            this.previousUser = null;
            this.nextUser = null;

            this.checkForOtherUsers();
            $(this.swalContent).empty().append(this.popupTemplate());
            this.createPopup();
            this.checkWidth();

            $('.swal-content .testimonial .testimonial-slick').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                const nxt = $(slick.$slides[nextSlide]).data('slick-index');
                this.currentVideo = nxt;

                this.checkForOtherUsers();
                this.updatePreviousAndNext();
                this.updateUserInfo();
            }).on('afterChange', () => {
                this.stopVideos();
                this.checkWidth();
            }).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: this.currentVideo,
                infinite: true,
                arrows: false,
                swipe: true,
                waitForAnimate: false,
                adaptiveHeight: true,
                rows: 0,
                slide: '.preview',
            });

            this.addEventListeners();
            this.videoEventListeners();
            this.stopVideos();

            $('.slick-list').removeAttr('style');
            this.mutationObserver.observe($('.swal-overlay')[0], { attributes: true, attributeOldValue: true });
        }).catch(error => {
            console.log(error);
        });
    };

    checkForOtherUsers() {
        this.mainUser = this.testimonials[this.currentVideo];

        if (this.testimonials.length === 2) {
            this.previousUser = this.currentVideo === 0 ? this.testimonials[this.testimonials.length-1] : this.testimonials[this.currentVideo-1];
        }
        if (this.testimonials.length > 2) {
            this.previousUser = this.currentVideo === 0 ? this.testimonials[this.testimonials.length-1] : this.testimonials[this.currentVideo-1];
            this.nextUser = this.currentVideo === this.testimonials.length - 1 ? this.testimonials[0] : this.testimonials[this.currentVideo + 1];
        }
    };

    stopVideos() {
        if (this.testimonials.length !== 1) {
            $('.testimonial-slick .preview.slick-cloned').each((index, element) => {
                const vimeoVideo = $(element).find('.video-container iframe')[0];
                const video = $(element).find('video')[0];

                if (vimeoVideo) {
                    const player = new Player(vimeoVideo);
                    this.vimeoPlayers.push(player);

                    player.pause().catch(e => console.log(e));
                    player.setCurrentTime(0).catch(e => console.log(e));
                }
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                }
            });
            $('.testimonial-slick .preview:not(.slick-cloned)').each((index, element) => {
                const vimeoVideo = $(element).find('.video-container iframe')[0];
                const video = $(element).find('video')[0];
                const elementId = $(element).data('slick-index');
                const hidden = $(element).attr('aria-hidden');

                if (vimeoVideo) {
                    const player = new Player(vimeoVideo);

                    this.vimeoPlayers.push(player);

                    if (elementId !== this.currentVideo && hidden) {
                        player.pause().catch(e => console.log(e));
                        player.setCurrentTime(0).catch(e => console.log(e));
                    } else {
                        player.play().catch(e => console.log(e));
                        player.setVolume(1).catch(e => console.log(e));
                    }
                }
                if (video) {
                    if (elementId !== this.currentVideo && hidden) {
                        video.pause();
                        video.currentTime = 0;
                    } else {
                        video.play();
                    }
                }
            });
            $('.testimonial-slick .preview').each((index, element) => {
                const elementId = $(element).data('slick-index');
                const hidden = $(element).attr('aria-hidden');

                if (elementId !== this.currentVideo && hidden) {
                    $(element).find('.thumbnail').removeClass('hidden')
                }
            });
        } else {
            $('.testimonial-slick .preview').each((index, element) => {
                const vimeoVideo = $(element).find('.video-container iframe')[0];
                const video = $(element).find('video')[0];

                if (vimeoVideo) {
                    const player = new Player(vimeoVideo);
                    player.play().catch(e => console.log(e));
                    player.setVolume(1).catch(e => console.log(e));
                }

                if (video) {
                    video.play();
                }
            });
        }
    };

    videoEventListeners() {
        $('.testimonial-slick .preview:not(.slick-cloned)').each((index, element) => {
            let bufferStarted = false;
            const vimeoVideo = $(element).find('.video-container iframe')[0];

            if (vimeoVideo) {
                const player = new Player(vimeoVideo);

                player.on('bufferstart', () => {
                    bufferStarted = true;
                });

                player.on('bufferend', () => {
                    bufferStarted = false;
                    $(element).find('.thumbnail').addClass('hidden');
                });

                player.on('play', () => {
                    if (!bufferStarted) {
                        $(element).find('.thumbnail').addClass('hidden');
                    }
                });

                player.on('pause', () => {
                });

                player.on('ended', (event) => {
                    this.goToNextUser();
                });
            }
        });
    };

    checkWidth() {
        if (parseInt(this.mainUser.width) > parseInt(this.mainUser.height)) {
            $('.swal-testimonial').addClass('wide-video');
        } else {
            $('.swal-testimonial').removeClass('wide-video');
        }
    }

    goToNextUser() {
        const $slick = $('.swal-content .testimonial .testimonial-slick');
        $slick.slick('slickNext');
    }

    updatePreviousAndNext() {
        $('.same-questions').empty().append(`
            <div class="same-question left">
                ${this.previousUser ? `
                    <div class="user" data-testimonial-id=${this.previousUser.id} data-question-id=${this.previousUser.question.id} data-next="${this.currentVideo - 1}">
                        <div class="image">
                            <img src="${this.previousUser.author.avatar}" />
                        </div>
                        <p class="name">${this.previousUser.author.name}</p>
                    </div>
                ` : ""}
            </div>
            <div class="same-question right">
                ${this.nextUser ? `
                    <div class="user" data-testimonial-id=${this.nextUser.id} data-question-id=${this.nextUser.question.id} data-next="${this.currentVideo + 1}">
                        <div class="image">
                            <img src="${this.nextUser.author.avatar}" />
                        </div>
                        <p class="name">${this.nextUser.author.name}</p>
                    </div>
                ` : ""}
                ${this.showViewAllButton ? `
                    <a href="#" class="view-all">
                        <div class="text">
                            View<br>all
                        </div>
                    </a>
                ` : ""}
            </div>
        `);
    };

    updateUserInfo() {
        $('.person-info.single-question-popup').empty().append(this.pearsonInfoTemplate());
        $('.tags.single-question-popup').empty().append(this.tagsTemplate());
    }

    popupTemplate() {
        return `
        <button class="swal-close" onClick="swal.close()">
            ${this.closeButton}
        </button>
        <div class="testimonial-slick">
            <div class="same-questions">
                <div class="same-question left">
                    ${this.previousUser ? `
                        <div class="user" data-testimonial-id=${this.previousUser.id} data-question-id=${this.previousUser.question.id} data-next="${this.currentVideo - 1}">
                            <div class="image">
                                <img src="${this.previousUser.author.avatar}" />
                            </div>
                            <p class="name">${this.previousUser.author.name}</p>
                        </div>
                    ` : ""}
                </div>
                <div class="same-question right">
                    ${this.nextUser ? `
                        <div class="user" data-testimonial-id=${this.nextUser.id} data-question-id=${this.nextUser.question.id} data-next="${this.currentVideo + 1}">
                            <div class="image">
                                <img src="${this.nextUser.author.avatar}" />
                            </div>
                            <p class="name">${this.nextUser.author.name}</p>
                        </div>
                    ` : ""}
                    ${this.showViewAllButton ? `
                        <a href="#" class="view-all">
                            <div class="text">
                                View<br>all
                            </div>
                        </a>
                    ` : ""}
                </div>
            </div>
            ${this.testimonials.map((testimonial, index) => {
                return `
                <div class="preview" data-testimonial-id=${testimonial.id}>
                    <div class="video-container">
                        ${testimonial.type ?
                            this.iframeTemplate(testimonial)
                            :
                            `<video autoplay loop class="swal-video"><source src="${testimonial.video}"></video>`
                        }
                    </div>
                </div>`
            }).join("")
            }
            <div class="testimonial-question">
                ${this.mainUser.question.question}
            </div>
        </div>
        <div class="person-info single-question-popup">
            ${this.pearsonInfoTemplate()}
        </div>
        <div class="tags single-question-popup">
            ${this.tagsTemplate()}
        </div>
        ${this.showViewAllButton ? `
            <a href="#" class="view-all view-all-mobile">
                <div class="text">
                    View<br>all
                </div>
            </a>
        ` : ""}
        `;
    };

    pearsonInfoTemplate() {
        return `
            <img class="person-image" src="${this.mainUser.author.avatar}" />
            <div class="name">${this.mainUser.author.name}</div>
            <div class="position">${this.mainUser.author.position}</div>
        `;
    };

    tagsTemplate() {
        return this.mainUser.categories.map(category => {
            return `<a class="tag" data-id="${category.id}">${category.category}</a>`
        }).join("");
    };

    slideTemplate(user) {
        return `
            <div class="preview">
                <div class="video-container">
                    ${user.type ?
                        this.iframeTemplate(user)
                        :
                        `<video autoplay loop class="swal-video"><source src="${user.video}"></video>`
                    }
                </div>
            </div>
        `;
    };

    iframeTemplate(testimonial) {
        return `
            <iframe src="${testimonial.video}" frameborder="0" allow="autoplay" allowfullscreen=""></iframe>
            <div class="thumbnail">
                <img class="loading-icon" src="/static/images/loading.svg" />
                <img class="placeholder" src="${testimonial.vimeoThumbnail}" />
            </div>
        `;
    };

}